<template>
  <md-modal-dialog
    class="md-dialog"
    :md-click-outside-to-close="false"
    @md-opened="event = 'md-opened'"
    @md-clicked-outside="onModalClose"
    @keydown.esc="onModalClose"
    v-slot="{filterValue}"
  >
    <ModalWrapper>
      <button class="btn btn-icon btn-close" @click="onModalClose">
        <IconCross />
        <span>close</span>
      </button>
      <TravelersFilter :value="filterValue" @change="onChange" @close="onSubmit" />
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
import TravelersFilter from './travelers-filter';
import {ModalWrapper} from '@mobi-components/amex-bluesky-components';
import IconCross from '../../old-home-page/destination-details/icon-cross';

export default {
  name: 'travelers-dialog',
  components: {
    ModalWrapper,
    TravelersFilter,
    IconCross,
  },
  data() {
    return {
      value: null,
    };
  },
  methods: {
    onChange(value) {
      this.value = value;
    },
    onModalClose() {
      this.$modal.submit();
    },
    onSubmit() {
      this.$modal.submit(this.value);
    },
  },
};
</script>

<style scoped>
.md-dialog {
  /* --md-theme-default-primary: var(--primary);
  --md-theme-default-primary-on-background: var(--primary);
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  ); */
  pointer-events: none;
}

.btn {
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  color: #fff;
  cursor: pointer;
}

.btn-close:hover {
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
}

.btn-close {
  position: absolute;
  font-size: 14px;
  color: #fff;

  top: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s ease background;
  padding: 20px 20px 11px;
  border-radius: 0 18px;
  z-index: 10;
}

.btn-close > span {
  font-size: 0;
}
</style>
